exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".logo__link,.logo__link:hover,.logo__link:visited{color:#000}.logo__icon{width:96px;height:96px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/logo/logo.scss
// module id = 841
// module chunks = 0